module.exports = __webpack_public_path__ + "static/media/international_students.55e25bbf.jpg";